export const DURACION = 0;
